// Vendor
import * as signalR from '@microsoft/signalr';

// Internal
import { store, StoreMutations, StoreActions } from '@/store';
import { PagedList, Lavorazione, LavorazioneSlim, VariazioneLavorazione, EsitoAzione, Utente, OrdineSlim, Ordine, Distinta,
  ProgressoLavorazione, AzioniLavorazione, Azione, ProgressoSpedizione, EsitoOperazioneConValoreDiRitorno, LavorazionePerSpedizione,
  Spedizione, EsitoOperazione, DatiLookup, FinderSpedizioni, FinderDistinteStatiche,
  ComunicazioneVariazioneRigaDistinta, VariazioneRigaDistinta, DatiLookupDefault, FinderReintegri, Reintegro, GruppoDistinte, GruppoVenduto, FinderVenduto, FinderOrdiniMTM, OrdineMTMTestata, OrdineMTM, AggiornaDatiOrdineFornitoreRigaMTMRequest, AggiornaNoteOrdineFornitoreRigaMTMRequest, ConfermaVariazioneTestataMTMRequest, ConfermaVariazioneTestataArrayItemsRequest, ConfermaVariazioneSubArrayMTMRequest, RequestSalvaDatiAggiuntiviLavorazione, RequestSalvaDatiAggiuntiviOrdine, FinderLavorazioni, FinderOrdini, FinderGruppoLavorazioniPerStagione, GruppoLavorazioniPerStagione, FinderGruppoLavorazioniPerFase, GruppoLavorazioniPerFase, FinderGruppoLavorazioniPerConsegna, GruppoLavorazioniPerConsegna, FinderGruppoLavorazioniPerLotto, GruppoLavorazioniPerLotto, TextValueItem } from '@/models';
import { tokenService } from './token.service';
import { config } from '@/infrastructure';
import dayjs from 'dayjs';
import { OrdineSpacchettatoTestata } from '@/models/OrdineSpacchettatoTestata';
import { OrdineSpacchettatoLista } from '@/models/OrdineSpacchettatoLista';
import { OrdineSpacchettatoDettaglio } from '@/models/OrdineSpacchettatoDettaglio';

class HubClient {
    hubConnection!: signalR.HubConnection;
    clientId!: string;

    async init(): Promise<boolean> {

      console.info('HubClient init start()');

      this.clientId = `VUE_TS_CLIENT_${Math.round(1000 * Math.random())}`;

      //this.hubConnection = new signalR.HubConnectionBuilder().withUrl(config.hubUrl).build();
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(config.hubUrl, {
          accessTokenFactory: () => this.getLoginToken()
        })
        .withAutomaticReconnect()
        .build();

      try {
        await this.hubConnection.start();
      } catch (err) {
        console.warn('hubConnection.start', err);
        return false;
      }

      this.hubConnection.on('OnLavorazioneDPCModificata', async (lavorazione) => {
        console.log("Ricevuta notifica di aggiornamento lavorazione: " + lavorazione);

        store.dispatch(StoreActions.UpdateLavorazione, lavorazione);
      });

      this.hubConnection.on('OnLavorazioniDPCMultipleModificate', async (ids: string[]) => {
        console.log("Ricevuta notifica di aggiornamento lavorazioni multiple: " + ids);

        store.dispatch(StoreActions.UpdateGruppoLavorazioni, ids);
      });

      console.info('HubClient init completed');

      return true;
    }

    async close(): Promise<void> {
      if(this.hubConnection) {
        await this.hubConnection.stop();
      }
    }

    getLoginToken(): string {
      return tokenService.getTokenOrDefault("ERR_NO_TOKEN_AVAILABLE");
    }

    private async _invokeHubAction<T>(action: string, ...params: any[]) : Promise<T> {
      try {
        let result: T = await this.hubConnection.invoke(action, ...params);
        return result;
      } catch (err) {
        console.log(JSON.stringify(err));
        store.commit(StoreMutations.SetMessaggiErrore, [err])
        //throw err;
        return Promise.reject(err);
      }
    }

    async watchLavorazione(id: string) : Promise<any> {
      return await this._invokeHubAction<any>('AddToLavorazioneDPCNotificationGroup', id);
    }

    async unwatchLavorazione(id: string) : Promise<any> {
      return await this._invokeHubAction<any>('RemoveFromLavorazioneDPCNotificationGroup', id);
    }

    async watchLavorazioni(ids: string[]) : Promise<any> {
      return await this._invokeHubAction<any>('AddToLavorazioniDPCNotificationGroup', ids);
    }

    async unwatchLavorazioni(ids: string[]) : Promise<any> {
      return await this._invokeHubAction<any>('RemoveFromLavorazioniDPCNotificationGroup', ids);
    }

    async watchLavorazioniFornitore(idFornitore: string) : Promise<any> {
      //return await this._invokeHubAction<any>('AddToFornitoreDPCNotificationGroup', idFornitore);
    }

    async unwatchLavorazioniFornitore(idFornitore: string) : Promise<any> {
      //return await this._invokeHubAction<any>('RemoveFromFornitoreDPCNotificationGroup', idFornitore);
    }

    async watchNotificheGruppi(): Promise<any> {
      return await this._invokeHubAction<any>('AddToUserNotificationGroup');
    }

    async unwatchNotificheGruppi(): Promise<any> {
      return await this._invokeHubAction<any>('RemoveFromUserNotificationGroup');
    }

    // async getDistinteStatiche(finder: FinderDistinteStatiche) : Promise<PagedList<Distinta>> {
    //   return await this._invokeHubAction<PagedList<Distinta>>('GetDistinteStaticheDPCDaFinder', finder);
    // }
    async getGruppiDistinteStatiche(finder: FinderDistinteStatiche) : Promise<PagedList<GruppoDistinte>> {
      return await this._invokeHubAction<PagedList<GruppoDistinte>>('GetGruppiDistinteStaticheDPCDaFinder', finder);
    }

    async getDistinteStatichePerModello(idModello: string) : Promise<Distinta[]> {
      return await this._invokeHubAction<Distinta[]>('GetDistinteStaticheDPCPerModello', idModello);
    }

    async getLookupFiltratiConsumi(stagione: string, filtroAvanzamenti: string[]) : Promise<any> {
      return await this._invokeHubAction<any>('GetLookupFiltratiConsumi', stagione, filtroAvanzamenti);
    }

    async getDistintaStaticaDaId(id: string) : Promise<Distinta> {
      return await this._invokeHubAction<Distinta>('GetDistintaStaticaDPCDaId', id);
    }

    async getDistintaStaticaDaStagioneModelloColore(stagione: string, modello: string, colore: string) : Promise<Distinta | null> {
      return await this._invokeHubAction<Distinta | null>('GetDistintaStaticaDPCDaStagioneModelloColore', stagione, modello, colore);
    }

    async comunicaVariazioniRigheDistinteDPC(comunicazioni : ComunicazioneVariazioneRigaDistinta[]){
      return await this._invokeHubAction<void>('ComunicaVariazioniRigheDistinteDPC', comunicazioni, false);
    }

    async comunicaConfermeVariazioniRigheDistinteDPC(comunicazioni : ComunicazioneVariazioneRigaDistinta[]) : Promise<boolean>{
      return await this._invokeHubAction<boolean>('ComunicaVariazioniRigheDistinteDPC', comunicazioni, true);
    }

    async consolidaVariazioniDistintaStatica(id: string) : Promise<Distinta> {
      return await this._invokeHubAction<Distinta>('ConsolidaVariazioniDistintaStatica', id);
    }

    //#region metodi lavorazione

    async getUtenti() : Promise<Utente[]> {
      return await this._invokeHubAction<Utente[]>('GetDatiUtentiDPC');
    }

    // async getOrdini(idFornitore: string) : Promise<OrdineSlim[]> {
    //   return await this._invokeHubAction<OrdineSlim[]>('GetOrdiniDPCDaIdFornitore', [], idFornitore);
    // }

    async getDatiLookup() : Promise<DatiLookup> {
      let dati = await this._invokeHubAction<DatiLookup>('GetDatiLookup');
      dati.umRigheDistinte = DatiLookupDefault.umRigheDistinte;
      return dati;
    }

    async getOrdiniMTM(finder: FinderOrdiniMTM) : Promise<PagedList<OrdineMTMTestata>> {
      return await this._invokeHubAction<PagedList<OrdineMTMTestata>>('GetOrdiniMTMFilologDaFinder', finder);
    }

    async getGruppoLavorazioniPerStagione(finder: FinderGruppoLavorazioniPerStagione) : Promise<PagedList<GruppoLavorazioniPerStagione>> {
      return await this._invokeHubAction<PagedList<GruppoLavorazioniPerStagione>>('GetGruppoLavorazioniPerStagioneDPCDaFinder', finder);
    }
    async getGruppoLavorazioniPerStagioneElencoStagioni(finder: FinderGruppoLavorazioniPerStagione) : Promise<TextValueItem[]> {
      return await this._invokeHubAction<TextValueItem[]>('GetGruppoLavorazioniPerStagioneElencoStagioniDPCDaFinder', finder);
    }

    async getGruppoLavorazioniPerFase(finder: FinderGruppoLavorazioniPerFase) : Promise<PagedList<GruppoLavorazioniPerFase>> {
      return await this._invokeHubAction<PagedList<GruppoLavorazioniPerFase>>('GetGruppoLavorazioniPerFaseDPCDaFinder', finder);
    }
    async getGruppoLavorazioniPerFaseElencoFasi(finder: FinderGruppoLavorazioniPerFase) : Promise<TextValueItem[]> {
      return await this._invokeHubAction<TextValueItem[]>('GetGruppoLavorazioniPerFaseElencoFasiDPCDaFinder', finder);
    }
    async getGruppoLavorazioniPerFaseElencoStagioni(finder: FinderGruppoLavorazioniPerFase) : Promise<TextValueItem[]> {
      return await this._invokeHubAction<TextValueItem[]>('GetGruppoLavorazioniPerFaseElencoStagioniDPCDaFinder', finder);
    }
    
    
    async getGruppoLavorazioniPerConsegna(finder: FinderGruppoLavorazioniPerConsegna) : Promise<PagedList<GruppoLavorazioniPerConsegna>> {
      return await this._invokeHubAction<PagedList<GruppoLavorazioniPerConsegna>>('GetGruppoLavorazioniPerConsegnaDPCDaFinder', finder);
    }
    async getGruppoLavorazioniPerConsegnaElencoStagioni(finder: FinderGruppoLavorazioniPerConsegna) : Promise<TextValueItem[]> {
      return await this._invokeHubAction<TextValueItem[]>('GetGruppoLavorazioniPerConsegnaElencoStagioniDPCDaFinder', finder);
    }
    async getGruppoLavorazioniPerConsegnaElencoConsegne(finder: FinderGruppoLavorazioniPerConsegna) : Promise<TextValueItem[]> {
      return await this._invokeHubAction<TextValueItem[]>('GetGruppoLavorazioniPerConsegnaElencoConsegneDPCDaFinder', finder);
    }

    async getGruppoLavorazioniPerLotto(finder: FinderGruppoLavorazioniPerLotto) : Promise<PagedList<GruppoLavorazioniPerLotto>> {
      return await this._invokeHubAction<PagedList<GruppoLavorazioniPerLotto>>('GetGruppoLavorazioniPerLottoDPCDaFinder', finder);
    }
    async getGruppoLavorazioniPerLottoElencoStagioni(finder: FinderGruppoLavorazioniPerLotto) : Promise<TextValueItem[]> {
      return await this._invokeHubAction<TextValueItem[]>('GetGruppoLavorazioniPerLottoElencoStagioniDPCDaFinder', finder);
    }
    async getGruppoLavorazioniPerLottoElencoLotti(finder: FinderGruppoLavorazioniPerLotto) : Promise<TextValueItem[]> {
      return await this._invokeHubAction<TextValueItem[]>('GetGruppoLavorazioniPerLottoElencoLottiDPCDaFinder', finder);
    }

    async getOrdini(finder: FinderOrdini) : Promise<PagedList<OrdineSlim>> {
      return await this._invokeHubAction<PagedList<OrdineSlim>>('GetOrdiniDPCSlimPaginati', finder);
    }

    async getOrdine(id: string) : Promise<Ordine | null> {
      return await this._invokeHubAction<Ordine | null>('GetOrdineDPCDaId', id);
    }

    async getOrdineMTM(id: string) : Promise<OrdineMTM | null> {
      return await this._invokeHubAction<OrdineMTM | null>('GetOrdineMTMFilologDaId', id);
    }
    async getOrdineMTMDaIdTestata(idTestata: string) : Promise<OrdineMTM | null> {
      return await this._invokeHubAction<OrdineMTM | null>('GetOrdineMTMFilologDaIdTestata', idTestata);
    }

    async getOrdineSpacchettatoTestata(id: string) : Promise<OrdineSpacchettatoTestata | null> {
      return await this._invokeHubAction<OrdineSpacchettatoTestata | null>('OrdiniSpacchettati_DatiTestataOrdine', id);
    }

    async getOrdineSpacchettatoLista(stagione: string, linea: string, numeroOrdine: string, page: number, pageSize: number) : Promise<OrdineSpacchettatoLista[] | null> {
      return await this._invokeHubAction<OrdineSpacchettatoLista[] | null>('OrdiniSpacchettati_ListaOrdiniSpacchettati', stagione, linea, numeroOrdine, page, pageSize);
    }
    async getOrdineSpacchettatoDettaglio(idLids: string[], page: number, pageSize: number) : Promise<OrdineSpacchettatoDettaglio[] | null> {
      return await this._invokeHubAction<OrdineSpacchettatoDettaglio[] | null>('OrdiniSpacchettati_DettagliOrdiniSpacchettati', idLids, page, pageSize);
    }

    

    // async getSpedizioni(idFornitore: string) : Promise<Spedizione[]> {
    //   return await this._invokeHubAction<Spedizione[]>('GetSpedizioniDPCDaIdFornitore', idFornitore);
    // }

    async getSpedizioni(finder: FinderSpedizioni) : Promise<PagedList<Spedizione>> {
      return await this._invokeHubAction<PagedList<Spedizione>>('GetSpedizioniDPCPaginate', finder);
    }

    async updateNoteOrdine(idOrdine: string, note: string): Promise<boolean> {
      let result = await this._invokeHubAction<EsitoOperazione>('AggiornaNoteOrdine', idOrdine, note);
      return result.eseguitaConSuccesso;
    }
    async updateNoteLavorazione(idLavorazione: string, note: string): Promise<boolean> {
      let result = await this._invokeHubAction<EsitoOperazione>('AggiornaNoteLavorazione', idLavorazione, note);
      return result.eseguitaConSuccesso;
    }
    async updateDatiOrdineFornitoreRigaMtm(request: AggiornaDatiOrdineFornitoreRigaMTMRequest): Promise<EsitoOperazione> {
      let result = await this._invokeHubAction<EsitoOperazione>('AggiornaDatiOrdineFornitoreRigaMTM', request);
      return result;
    }
    async updateNoteConsegnaRigaMtm(request: AggiornaNoteOrdineFornitoreRigaMTMRequest): Promise<EsitoOperazione> {
      let result = await this._invokeHubAction<EsitoOperazione>('AggiornaNoteConsegnaRigaMTM', request);
      return result;
    }
    

    async confermaVariazioneTestataOrdineMTM(request: ConfermaVariazioneTestataMTMRequest): Promise<EsitoOperazione> {
      let result = await this._invokeHubAction<EsitoOperazione>('ConfermaVariazioneTestataOrdineMTM', request);
      return result;
    }
    async confermaVariazioneSubArrayOrdineMTM(request: ConfermaVariazioneSubArrayMTMRequest): Promise<EsitoOperazione> {
      let result = await this._invokeHubAction<EsitoOperazione>('ConfermaVariazioneSubArrayOrdineMTM', request);
      return result;
    }
    async confermaVariazioneArrayItemsOrdineMTM(request: ConfermaVariazioneTestataArrayItemsRequest): Promise<EsitoOperazione> {
      let result = await this._invokeHubAction<EsitoOperazione>('ConfermaVariazioneArrayItemsOrdineMTM', request);
      return result;
    }

    // async getLavorazioniFornitore(idFornitore: string) : Promise<LavorazioneSlim[]> {
    //   // TODO: GetLavorazioniDPCSlimPaginati
    //   return await this._invokeHubAction<LavorazioneSlim[]>('GetLavorazioniDPCSlimDaIdFornitore', idFornitore);
    // }

    async getLavorazioniFornitore(finder: FinderLavorazioni) : Promise<PagedList<LavorazioneSlim>> {
      return await this._invokeHubAction<PagedList<LavorazioneSlim>>('GetLavorazioniDPCSlimPaginati', finder);
    }

    async getLavorazioni(ids: string[]) : Promise<Lavorazione[]> {
      return await this._invokeHubAction<Lavorazione[]>('GetLavorazioniDPCDaListaId', ids);
    }

    async getLavorazione(id: string) : Promise<Lavorazione | null> {
      return await this._invokeHubAction<Lavorazione | null>('GetLavorazioneDPCDaId', id);
    }
    async searchLavorazione(id: string) : Promise<Lavorazione | null> {
      return await this._invokeHubAction<Lavorazione | null>('SearchLavorazioneDPCDaId', id);
    }

    async getLavorazioneDaSerialeEpc(serialeEpc: string) : Promise<Lavorazione | null> {
      return await this._invokeHubAction<Lavorazione | null>('GetLavorazioneDPCDaSerialeEpc', serialeEpc);
    }

    async getDistintaDinamica(id: string) : Promise<Distinta | null> {
      return await this._invokeHubAction<Distinta | null>('GetDistintaDinamicaDPCDaId', id);
    }

    async getRigheSpedibiliPerFornitore(idFornitore: string) : Promise<LavorazionePerSpedizione[]> {
      return await this._invokeHubAction<LavorazionePerSpedizione[]>('GetLavorazioniDPCSlimDaIdFornitorePerSpedizione', idFornitore);
    }

    async getRigheSpedibiliPerLavorazioni(ids: string[]) : Promise<LavorazionePerSpedizione[]> {
      return await this._invokeHubAction<LavorazionePerSpedizione[]>('GetLavorazioniDPCSlimDaListaIdPerSpedizione', ids);
    }

    async creaSpedizione(numeroDDT: string, dataDDT: string | null, numColli: number, notaSpedizione: string) : Promise<EsitoOperazioneConValoreDiRitorno> {
      let errDefault = {
        eseguitaConSuccesso: false,
        valoreDiRitorno: '',
        errori: ['Operazione di creazione spedizione fallita con errore sconosciuto.']
      };
      return await this._invokeHubAction<EsitoOperazioneConValoreDiRitorno>('CreaSpedizioneDPC', numeroDDT, dataDDT, numColli, notaSpedizione);
    }

    async aggiungiRigaSpedizioneDaLavorazione(idSpedizione: string, idLavorazione: string) : Promise<EsitoOperazione> {
      let errDefault = {
        eseguitaConSuccesso: false,
        errori: ['Operazione di creazione spedizione fallita con errore sconosciuto.']
      };
      return await this._invokeHubAction<EsitoOperazioneConValoreDiRitorno>('AggiungiRigaSpedizioneDaLavorazione', idSpedizione, idLavorazione);
    }
    async aggiungiRigaSpedizioneDaEpcLavorazione(idSpedizione: string, epcLavorazione: string) : Promise<EsitoOperazioneConValoreDiRitorno> {
      let errDefault = {
        eseguitaConSuccesso: false,
        errori: ['Operazione di creazione spedizione fallita con errore sconosciuto.']
      };
      return await this._invokeHubAction<EsitoOperazioneConValoreDiRitorno>('AggiungiRigaSpedizioneDaEpcLavorazione', idSpedizione, epcLavorazione);
    }
    async eliminaRigaSpedizioneDaIdLavorazione(idSpedizione: string, idLavorazione: string) : Promise<EsitoOperazione> {
      let errDefault = {
        eseguitaConSuccesso: false,
        errori: ['Operazione di creazione spedizione fallita con errore sconosciuto.']
      };
      return await this._invokeHubAction<EsitoOperazione>('RimuoviRigaSpedizioneDaIdLavorazione', idSpedizione, idLavorazione);
    }

    async eliminaSpedizione(idSpedizione: string) : Promise<EsitoOperazione> {
      let errDefault = {
        eseguitaConSuccesso: false,
        errori: ['Operazione di creazione spedizione fallita con errore sconosciuto.']
      };
      return await this._invokeHubAction<EsitoOperazione>('RimuoviSpedizione', idSpedizione);
    }

    async aggiornaSpedizione(spedizione: Spedizione) : Promise<EsitoOperazione> {
      let errDefault = {
        eseguitaConSuccesso: false,
        errori: ['Operazione di aggiornamento spedizione fallita con errore sconosciuto.']
      } as EsitoOperazione;
      return await this._invokeHubAction<EsitoOperazione>('AggiornaTestataSpedizioneDPC', spedizione);
    }

    async getAzioniPossibiliPerLavorazione(id: string) : Promise<Azione[]> {
      return await this._invokeHubAction<Azione[]>('GetAzioniPossibiliInStatoCorrente', id);
    }

    async getAzioniPossibiliPerLavorazioni(ids: string[]) : Promise<AzioniLavorazione[]> {
      return await this._invokeHubAction<AzioniLavorazione[]>('GetAzioniPossibiliInStatoCorrentePerLavorazioniMultiple', ids);
    }

    async getSchedeModelliDaModelloEStagione(modello:string, stagione: string) : Promise<string[]> {
      return await this._invokeHubAction<string[]>('GetModelliSchedePerModelloEStagione', modello, stagione);
    }
    async getSpedizione(id: string) : Promise<Spedizione | null> {
      return await this._invokeHubAction<Spedizione | null>('GetSpedizioneDPCDaId', id);
    }

    async getSpedizioniPerFornitore(id: string) : Promise<Spedizione[]> {
      return await this._invokeHubAction<Spedizione[]>('GetSpedizioniDPCDaIdFornitore', id);
    }

    async getVenduto(finder: FinderVenduto): Promise<PagedList<GruppoVenduto>> {
      return await this._invokeHubAction<PagedList<GruppoVenduto>>('GetVendutoDPCPaginato', finder);
    }

    async getReintegri(finder: FinderReintegri) : Promise<PagedList<Reintegro>> {
      return await this._invokeHubAction<PagedList<Reintegro>>('GetReintegriDPCPaginati', finder);
    }
    async getReintegro(id: string) : Promise<Reintegro | null> {
      return await this._invokeHubAction<Reintegro | null>('GetReintegroDPCDaId', id);
    }
    //#region Workflow lavorazione (dibattito - cambio stato - progresso)


    private endpointPerAzione = new Map<string, string[]>([
      [Azione.ACCETTA, ['EseguiAzioneAccetta', 'EseguiAzioneAccettaSuLavorazioniMultiple']],
      [Azione.FORZA_ACCETTAZIONE_DA_PARTE_DI_BC, ['EseguiAzioneForzaAccettazioneDaParteDiBC', 'EseguiAzioneForzaAccettazioneDaParteDiBCSuLavorazioniMultiple']],
      [Azione.CONSEGNA_A_FORNITORE, ['EseguiAzioneConsegnaAFornitore', 'EseguiAzioneConsegnaAFornitoreSuLavorazioniMultiple']],
      [Azione.FORZA_CONSEGNA_A_FORNITORE_DA_PARTE_DI_BC, ['EseguiAzioneForzaConsegnaAFornitoreDaParteDiBC', 'EseguiAzioneForzaConsegnaAFornitoreDaParteDiBCSuLavorazioniMultiple']],
      [Azione.REGISTRA_CONSEGNA_A_FORNITORE, ['EseguiAzioneRegistraConsegnaAFornitore', 'EseguiAzioneRegistraConsegnaAFornitoreSuLavorazioniMultiple']],
      [Azione.INIZIA_LAVORAZIONE, ['EseguiAzioneIniziaLavorazione', 'EseguiAzioneIniziaLavorazioneSuLavorazioniMultiple']],
      [Azione.COMPLETA_LAVORAZIONE, ['EseguiAzioneCompletaLavorazione', 'EseguiAzioneCompletaLavorazioneSuLavorazioniMultiple']],
      [Azione.RICONSEGNA_A_BC, ['EseguiAzioneRiconsegnaABC', 'EseguiAzioneRiconsegnaABCSuLavorazioniMultiple']],
      [Azione.REGISTRA_RIENTRO, ['EseguiAzioneRegistraRientro', 'EseguiAzioneRegistraRientroSuLavorazioniMultiple']]
    ]);

    private _esitoAzioneErrDefault: EsitoAzione = {
      idLavorazioneDpc: '',
      eseguitaConSuccesso: false,
      errori: ["Errore durante il tentativo di richiesta di variazione."]
    };

    //#region metodi per singola lavorazione

    async salvaDatiAggiuntiviLavorazione(request: RequestSalvaDatiAggiuntiviLavorazione) : Promise<EsitoAzione> {
      return await this._invokeHubAction<EsitoAzione>('SalvaDatiAggiuntiviLavorazione', request);
    }
    async salvaDatiAggiuntiviOrdine(request: RequestSalvaDatiAggiuntiviOrdine) : Promise<EsitoAzione> {
      return await this._invokeHubAction<EsitoAzione>('SalvaDatiAggiuntiviOrdine', request);
    }

    async richiediVariazioneLavorazione(id: string, variazione: VariazioneLavorazione) : Promise<EsitoAzione> {
      return await this._invokeHubAction<EsitoAzione>('EseguiAzioneRichiediVariazione', id, variazione);
    }

    async aggiornaProgressoLavorazione(progresso: ProgressoLavorazione) : Promise<EsitoAzione> {
      return await this._invokeHubAction<EsitoAzione>('AddProgressoLavorazioneDPCToLavorazioneDPC', progresso);
    }

    async eseguiAzionePerLavorazione(azione: Azione, id: string) : Promise<EsitoAzione> {
      let endpoints = this.endpointPerAzione.get(azione);
      if(endpoints) {
        return await this._invokeHubAction<EsitoAzione>(endpoints[0], id);
      }

      return {
        idLavorazioneDpc: id,
        eseguitaConSuccesso: false,
        errori: ["Azione richiesta non riconosciuta!"]
      };
    }

    //#endregion fine metodi per singola lavorazione

    //#region metodi per lavorazioni multiple

    async richiediVariazioniLavorazioni(ids: string[], variazione: VariazioneLavorazione) : Promise<EsitoAzione[]> {
      return await this._invokeHubAction<EsitoAzione[]>('EseguiAzioneRichiediVariazioneSuLavorazioniMultiple', ids, variazione);
    }

    async aggiornaProgressiLavorazione(progressi: ProgressoLavorazione[]) : Promise<EsitoAzione> {
      return await this._invokeHubAction<EsitoAzione>('AddProgressiLavorazioneDPCTolavorazioneDPC', progressi);
    }

    async eseguiAzionePerLavorazioni(azione: Azione, ids: string[]) : Promise<EsitoAzione[]> {
      let endpoints = this.endpointPerAzione.get(azione);
      if(endpoints) {
        return await this._invokeHubAction<EsitoAzione[]>(endpoints[1], ids);
      }

      return ids.map(id => { return {
        idLavorazioneDpc: id,
        eseguitaConSuccesso: false,
        errori: ["Azione richiesta non riconosciuta!"]
      }});
    }

    async stampaEtichettaPerLavorazioneETaglia(idLavorazione : string, indiceTaglia : string, operazione: string) : Promise<EsitoAzione>
    {
      return await this._invokeHubAction<EsitoAzione>('EseguiOperazioneEtichettaPerLavorazione', idLavorazione, indiceTaglia, operazione );
    }

    async stampaEtichettePerOrdine(idOrdine : string, operazione: string) : Promise<EsitoAzione>
    {
      return await this._invokeHubAction<EsitoAzione>('EseguiOperazioneEtichettaPerOrdine', idOrdine, operazione );
    }

    async stampaEtichettePerOrdineMTM(idOrdine : string, operazione: string) : Promise<EsitoAzione>
    {
      return await this._invokeHubAction<EsitoAzione>('EseguiOperazioneEtichettaPerOrdineMTM', idOrdine, operazione );
    }
    
    async getOperazioniStampaBrehmeDisponibiliPerLavorazione(idLavorazione: string) : Promise<boolean>
    {
        return await this._invokeHubAction<boolean>('OperazioniEtichetteDremeDisponibiliPerLavorazione', idLavorazione);
    }

    async getOperazioniStampaBrehmeDisponibiliPerOrdine(idOrdine: string) : Promise<boolean>
    {
        return await this._invokeHubAction<boolean>('OperazioniEtichetteDremeDisponibiliPerOrdine', idOrdine);
    }

    async getResetEPCDisponibile() : Promise<boolean>
    {
        return await this._invokeHubAction<boolean>('OperazioneEtichettaDremaResetEpcDisponibile');
    }

    async getStampaEtichetteNoRfidDisponibile() : Promise<boolean>
    {
      return await this._invokeHubAction<boolean>('GetStampaEtichetteNoRfidDisponibile');
    }

    async getStampaEtichetteRfidDisponibile() : Promise<boolean>
    {
      return await this._invokeHubAction<boolean>('GetStampaEtichetteRfidDisponibile');
    }

    //#endregion fine metodi per lavorazioni multiple

    //#endregion fine Workflow lavorazione

    //#endregion metodi lavorazione
}

export const hub = new HubClient();
